exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".half-col[data-v-6509a0c8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;text-align:center;--img-bottom-spacing:50px}.vw-component[data-v-6509a0c8]{padding-bottom:0!important}.vw-component-indicator[data-v-6509a0c8]{margin-bottom:var(--img-bottom-spacing)}img[data-v-6509a0c8]{width:100%;aspect-ratio:1/1;-o-object-fit:cover;object-fit:cover;margin-top:auto}@media (min-width:62em){.half-col[data-v-6509a0c8],.vw-component-content[data-v-6509a0c8],.vw-component-title[data-v-6509a0c8]{text-align:left}.vw-component-indicator[data-v-6509a0c8]{margin-left:0;margin-bottom:var(--img-bottom-spacing)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6509a0c8","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/vuejs/frontend/2023-launch/components/AppHalfCol.vue
// module id = 6tEa
// module chunks = 4